module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-honda.947062c0.jpg";